import styled from '@emotion/styled';
import {Block} from '@travel-frontend/ui-components';

export const HotelList = styled(Block)`
  width: 367px;
  margin: 16px 16px 16px -8px;
  padding-left: 24px;
  overflow-y: hidden;
  scrollbar-gutter: stable;

  &:hover,
  &:focus {
    overflow-y: auto;
  }
`;
